import Vue from 'vue'
import VueRouter from 'vue-router'
import CollectForm from './views/CollectForm'

Vue.use(VueRouter)

const routes = [
  // { path: '/', redirect: '/collectForm' },
  {
    path: '/form/:id',
    props: true,
    name: 'collectForm',
    component: CollectForm,
    meta: { title: '表单' }
  },
  {
    path: '/template/:id',
    props: true,
    name: 'template',
    component: () => import('./views/Template'),
    meta: { title: '模板' }
  },
  {
    path: '/info/:id?',
    props: true,
    name: 'info',
    component: () => import('./views/Info'),
    meta: { title: '提示' }
  },
  {
    path: '/history/:id',
    props: true,
    name: 'History',
    component: () => import('./views/History'),
    meta: { title: '历史提交记录' }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/idata/collect',
  routes
})

export default router
